(() => {
  if (customElements.get('smk-install-estimator')) return;
  const rates = {
    Melbourne: { single: 170, double: 220, commercial: 200 },
    Sydney: { single: 200, double: 220, commercial: 250 }
  };
  const money = value => new Intl.NumberFormat('en-AU', {
    style: 'currency', currency: 'AUD', maximumFractionDigits: 0
  }).format(value);

  customElements.define('smk-install-estimator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-install-open]');
      this.city = this.querySelector('[data-install-city]');
      this.property = this.querySelector('[data-install-property]');
      this.storeys = this.querySelector('[data-install-storeys]');
      this.count = this.querySelector('[data-install-count]');
      this.result = this.querySelector('[data-install-result]');
      this.followup = this.querySelector('[data-install-followup]');
      this.booking = this.querySelector('[data-install-booking]');
      this.form = this.booking.querySelector('form');
      this.opener.addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[data-install-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.opener.focus({ preventScroll: true }));
      this.addEventListener('input', event => {
        if (event.target.matches('[data-install-city], [data-install-property], [data-install-storeys], [data-install-count]')) this.resetEstimate();
      });
      this.querySelector('[data-install-calculate]').addEventListener('click', () => this.calculate());
      this.querySelector('[data-install-inputs]').addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target === this.count) {
          event.preventDefault();
          this.calculate();
        }
      });
      this.form.addEventListener('submit', event => {
        if (!this.estimate) {
          event.preventDefault();
          this.calculate();
        } else {
          try {
            sessionStorage.setItem(this.form.id, JSON.stringify({ city: this.city.value,
              property: this.property.value, storeys: this.storeys.value, count: this.count.value }));
          } catch (_) { /* Storage is optional; the native contact form still works. */ }
        }
      });
      this.resetEstimate();
      // Only reopen a Shopify response for this form, not another page contact form.
      if (location.hash === '#' + this.form.id && this.querySelector('[data-install-success], [data-install-form-error]')) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.form.id));
          if (saved) {
            for (const field of ['city', 'property', 'storeys', 'count']) this[field].value = saved[field];
            this.resetEstimate();
            this.calculate();
          }
          sessionStorage.removeItem(this.form.id);
        } catch (_) { /* Response feedback remains available without storage. */ }
        this.followup.hidden = false;
        this.booking.open = true;
        if (this.querySelector('[data-install-success]')) {
          this.querySelectorAll('[data-install-inputs], [data-install-calculate], .pdp-install-estimator__help, [data-install-count-error], .pdp-install-estimator__note').forEach(el => { el.hidden = true; });
          this.booking.querySelector('summary').hidden = true;
        }
        this.dialog.showModal();
      }
    }

    resetEstimate() {
      const commercial = this.property.value === 'Commercial';
      this.storeys.disabled = commercial;
      if (commercial) this.storeys.value = 'Not applicable';
      else if (this.storeys.value === 'Not applicable') this.storeys.value = '';
      this.estimate = 0;
      this.result.hidden = true;
      this.followup.hidden = true;
      this.querySelector('[data-install-count-error]').hidden = true;
      this.count.removeAttribute('aria-invalid');
    }

    calculate() {
      this.resetEstimate();
      for (const field of [this.city, this.property, this.storeys, this.count]) {
        if (!field.reportValidity()) return;
      }
      const city = this.city.value;
      const property = this.property.value;
      const residential = property === 'Residential';
      const count = Number(this.count.value);
      const validCount = this.count.validity.valid && Number.isSafeInteger(count) && count > 0;
      const invalid = Boolean(city && property && !validCount);
      this.querySelector('[data-install-count-error]').hidden = !invalid;
      this.count.setAttribute('aria-invalid', String(invalid));
      const key = residential ? (this.storeys.value === 'Single storey' ? 'single' : this.storeys.value === 'Double storey' ? 'double' : '') : 'commercial';
      const rate = city && property && key ? rates[city][key] : 0;
      this.estimate = rate && validCount ? rate * count : 0;
      this.result.hidden = !this.estimate;
      this.followup.hidden = !this.estimate;
      if (!this.estimate) return;
      this.querySelector('[data-install-total]').textContent = money(this.estimate) + ' AUD';
      this.querySelector('[data-install-breakdown]').textContent = `${count} ${count === 1 ? 'camera' : 'cameras'} × ${money(rate)} per camera`;
      const summary = { city, property, storeys: residential ? this.storeys.value : 'Not applicable', count,
        estimate: `${money(this.estimate)} AUD (${count} x ${money(rate)}/camera), indicative installation only` };
      for (const [key, value] of Object.entries(summary)) {
        const input = this.querySelector(`[data-install-summary="${key}"]`);
        if (input) input.value = value;
      }
    }
  });
})();
